import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { IoMenu, IoClose } from "react-icons/io5";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (isOpen) {
            const previousOverflow = document.body.style.overflow;
            document.body.style.overflow = "hidden";
            return () => {
                document.body.style.overflow = previousOverflow;
            };
        }
        return;
    }, [isOpen]);

    const handleLinkClick = () => {
        setIsOpen(false);
    };

    const navLinks = [
        { to: "/", label: "Home" },
        { to: "/work", label: "Work Experience" },
        { to: "/skills", label: "Skills" },
        { to: "/projects", label: "Projects" },
        { to: "/contact", label: "Contact" },
    ];

    return (
        <>
            <nav className="navbar-safe bg-gray-900 lg:bg-transparent">
                <div className="navbar-safe__inner px-0 lg:px-4">
                    <div className="w-full lg:max-w-7xl lg:mx-auto">
                        <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 backdrop-blur-lg bg-opacity-95 rounded-none lg:rounded-2xl border border-gray-700/50">
                            <div className="px-6 py-4 flex justify-between items-center">
                                {/* Logo/Name */}
                                <Link to="/" className="group">
                                    <div className="text-white text-2xl font-bold tracking-tight flex items-center gap-2">
                                        <span className="text-white">Ben</span>
                                        <span className="text-white">Gridley</span>
                                    </div>
                                </Link>

                                {/* Mobile Menu Icon */}
                                <button
                                    className="block lg:hidden text-white hover:text-blue-400 transition-colors"
                                    onClick={() => setIsOpen(true)}
                                    aria-label="Open menu"
                                >
                                    <IoMenu size={32} />
                                </button>

                                {/* Desktop Menu */}
                                <div className="hidden lg:flex lg:items-center gap-2">
                                    {navLinks.map((link) => (
                                        <Link
                                            key={link.to}
                                            to={link.to}
                                            className="relative px-4 py-2 text-gray-300 hover:text-white transition-all duration-300 group"
                                        >
                                            <span className="relative z-10">{link.label}</span>
                                            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/0 via-blue-400/0 to-cyan-400/0 group-hover:from-blue-500/10 group-hover:via-blue-400/10 group-hover:to-cyan-400/10 rounded-lg transition-all duration-300"></div>
                                            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-blue-400 to-cyan-400 group-hover:w-full transition-all duration-300"></div>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Fullscreen Mobile Menu Overlay */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-black bg-opacity-98 z-[60] flex flex-col items-center justify-center backdrop-blur-sm"
                    style={{
                        paddingTop: "env(safe-area-inset-top, 0px)",
                        paddingBottom: "env(safe-area-inset-bottom, 0px)",
                    }}
                >
                    <div
                        className="absolute top-0 left-0 right-0 bg-gradient-to-b from-black/90 to-transparent pointer-events-none"
                        style={{ height: "calc(env(safe-area-inset-top, 0px) + 6rem)" }}
                    />
                    <div
                        className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent pointer-events-none"
                        style={{ height: "calc(env(safe-area-inset-bottom, 0px) + 6rem)" }}
                    />
                    {/* Close Icon */}
                    <button
                        className="absolute top-8 right-8 text-white hover:text-blue-400 transition-colors"
                        onClick={() => setIsOpen(false)}
                        aria-label="Close menu"
                    >
                        <IoClose size={40} />
                    </button>

                    {/* Navigation Links */}
                    <div className="flex flex-col items-center gap-6">
                        {navLinks.map((link, index) => (
                            <Link
                                key={link.to}
                                to={link.to}
                                className="text-white text-3xl font-medium hover:text-transparent hover:bg-gradient-to-r hover:from-blue-400 hover:to-cyan-400 hover:bg-clip-text transition-all duration-300 transform hover:scale-110"
                                onClick={handleLinkClick}
                                style={{
                                    animation: `fadeInUp 0.5s ease-out ${index * 0.1}s both`
                                }}
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>
                </div>
            )}

            <style>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </>
    );
};

export default Navbar;
